module.exports = __webpack_public_path__ + "static/media/arrow-b.02d920bf.svg";